<!--光伏电站-发电量-->
<template>
  <div>
    <div class="quantity" v-for="(value,key) in quantity">
      <name-value-vertical-with-unit :name="maps[key]['name']" :value="transferValue(value)"
                                     :unit="transferUnit(value,maps[key]['unit'])"></name-value-vertical-with-unit>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import NameValueVerticalWithUnit from "@/components/zixitong/airSystem/NameValueVerticalWithUnit";

export default {
  name: "PowerQuantity",
  components: {NameValueVerticalWithUnit},
  data() {
    return {
      quantity: {
        power: 0,
        day: 0,
        month: 0,
        year: 0,
        total: 0,
      },

      /**
       * @description key-name-unit映射
       * */
      maps: {
        power: {name: "实时发电功率", unit: "kw"},
        day: {name: "今日发电量", unit: "kw·h"},
        month: {name: '本月发电量', unit: 'kw·h'},
        year: {name: '今年发电量', unit: 'kw·h'},
        total: {name: '累积发电量', unit: 'kw·h'}
      }
    }
  },
  created() {
    this.getData();
  },
  methods: {
    /**
     * @description 值转换。
     * @description 如果大于 10000 则除以 10000。
     * @description 保留两位小数。
     * @param {Number}value 需要被转换的值。
     * */
    transferValue(value) {
      if (value == null)
        return 0;

      if (value >= 10000) value = value / 10000;

      return value.toFixed(2);
    },

    /**
     * @description 单位转换。
     * @description 如果值大于 10000，则在单位前面加上 "万"。
     * @param {Number}value 值。
     * @param {String}unitOld 原来的单位。
     * */
    transferUnit(value, unitOld) {
      if (value > 10000) return "万 " + unitOld;

      return unitOld;
    },
    async getData() {
      /**
       * 如果数据源不为空对象，则直接渲染数据源中的数据
       * */
      let dataSourceStr = JSON.stringify(this.dataSource);
      if (dataSourceStr !== '{}') {
        this.quantity = {};
        let maps = this.maps;
        let dataSource = this.dataSource;
        for (let keyMap in maps) {
          for (let keyData in dataSource) {
            if (keyMap === keyData) {
              this.quantity[keyMap] = dataSource[keyData];
            }
          }
        }
        return;
      }


      /**
       * 下面是数据源为空对象的业务逻辑
       * */
      let params;

      const id = this.entity.id;
      const type = this.entity.type;
      if (type === 'project') {
        params = {'projectId': id};
      } else if (type === 'station') {
        params = {'stationId': id};
      } else if (type === 'inverter') {
        params = {'inverterId': id};
      } else {
        params = {'projectId': id};
      }
      let res = await api.photovoltaicGetPVGenElectricityInfo(params);
      if (res && res.status === 200) {
        this.quantity = {};
        let data = res.data.data;
        for (let keyMap in this.maps) {
          for (let keyData in data) {
            if (keyMap === keyData) {
              this.quantity[keyMap] = data[keyData];
            }
          }
        }
      }
    }
  },
  props: {
    /**
     * @description 此实体包含id和type。
     * @description 实体id：projectId（项目id），stationId（电站id），inverterId（逆变器id）。
     * @description 实体类型：project（项目），station（电站），inverter（逆变器）。
     * @description 因为不同的实体类型需要传递不同的参数，所以需要type属性表明是哪种实体类型。
     * @description 具体规则如下。
     * @description type=project, 接口为：http://xxx?projectId=xxx。
     * @description type=station, 接口为：http://xxx?stationId=xxx。
     * @description type=inverter, 接口为：http://xxx?inverterId=xxx。
     * @description type的取值范围为project/station/inverter,三取一。
     * */
    entity: {
      type: Object,
      default() {
        return {id: '', type: ''}
      }
    },
    /**
     * @description 数据源
     * @description 如果配置了数据源属性，则不再调用接口，直接渲染数据源的数据。
     * @description 如果没有数据源属性，则根据entity属性的id和type调用相应的接口。
     * @description 具体实现在getData()方法中。
     * */
    dataSource: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    'entity': {
      handler(newVal, oldVal) {
        this.getData();
      }
    },
  }
}
</script>

<style scoped lang="scss">
div.quantity {
  display: inline-block;
  width: 20%;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
